module.exports = __webpack_public_path__ + "img/adwall.4cfb9bfc.jpeg";